import React from 'react';
import Thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { Plugins } from '@leverege/plugin';
import { DynamicStore } from '@leverege/ui-plugin';
import { GlobalState, SelectionReducer, SelectReducer, UIReducer } from '@leverege/ui-redux';
import MoltenUtil from "../../MoltenUtil.js";
import Constants from "../../Constants.js";
const {
  REDUX_REDUCER,
  REDUX_MIDDLEWARE
} = Constants;

/**
 * Creates the provider for redux. This will install a DynamicStore and invoke
 * Constants.REDUX_MIDDLEWARE plugins to contribute to the middleware. The Thunk
 * middleware will be installed by default, using molten.getThunkArgs() as the args.
 */
export default {
  id: 'molten.ReduxInit',
  sort: -50,
  createProvider: (molten, ...children) => {
    // Get the Middleware plugins. All the inits should have been called.
    const middle = [...Plugins.get(REDUX_MIDDLEWARE)];
    middle.sort(MoltenUtil.numSortComparator);
    const dynamicStore = new DynamicStore({
      // eslint-disable-next-line react/destructuring-assignment
      config: molten.getValues(),
      reducers: createReducers(molten),
      middleware: [
      // eslint-disable-next-line react/destructuring-assignment
      Thunk.withExtraArgument(molten.getThunkArgs()), ...middle.map(plg => plg.createMiddleware(molten))]
    });
    const store = dynamicStore.create();
    // eslint-disable-next-line react/destructuring-assignment
    molten.set('store', store);
    GlobalState.attachStore(store);
    // eslint-disable-next-line react/destructuring-assignment
    return /*#__PURE__*/React.createElement(Provider, {
      store: molten.get('store')
    }, ...children);
  },
  createReducers: molten => {
    return {
      ui: UIReducer,
      selection: SelectionReducer,
      select: SelectReducer
    };
  }
};
function createReducers(molten) {
  const red = [...Plugins.get(REDUX_REDUCER)];
  red.sort(MoltenUtil.numSortComparator);
  const rtn = {};
  red.forEach(r => {
    const reducer = r.createReducers(molten);
    const keys = Object.keys(reducer);
    for (let n = 0; n < keys.length; n++) {
      const key = keys[n];
      if (rtn[key] != null) {
        // eslint-disable-next-line no-console
        console.error(`Molten reducer key(${key}) has already been taken. Consider using a DynamicReducer`);
      } else {
        rtn[key] = reducer[key];
      }
    }
  });
  return rtn;
}